<template>
  <div class="sk" :style="{ height: height, width: width, borderRadius: radius }" aria-hidden="true"></div>
</template>

<script>
/**
 * The shape of something that is on its way. A page shows these where its
 * numbers will be instead of a "LOADING…" overlay across everything, so the
 * layout is already there when the data arrives and nothing jumps.
 */
export default {
  name: "SkeletonBlock",
  props: {
    height: { type: String, default: "1rem" },
    width: { type: String, default: "100%" },
    radius: { type: String, default: "var(--r-sm)" },
  },
};
</script>

<style scoped>
.sk {
  background: linear-gradient(90deg, var(--bg-tertiary) 25%, var(--bg-hover) 50%, var(--bg-tertiary) 75%);
  background-size: 200% 100%;
}
</style>
